import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectionField", "selectionList"]
  static values = {
    key: { type: String, default: "target-user-id" },
    allTableIdsUrl: String
  }

  connect() {
    this.selectionFieldTarget.value = this.getIds().join(',')
    this.selectionListTarget.innerHTML = this.getIds().join(', ') || 'None'
    if (document.querySelector('input#selection_all')?.checked) this.handleSelectAll()
  }

  getIds(key = this.dataKey) {
    return Array.from(document.querySelectorAll('input[name="selection[]"]:checked'))
      .map(checkbox => checkbox.closest('tr')?.dataset[key])
      .filter(Boolean)
  }

  handleSelectAll() {
    const unchecked = Array.from(document.querySelectorAll('input[name="selection[]"]:not(:checked)'))
      .map(checkbox => checkbox.closest('tr')?.dataset[this.dataKey])
      .filter(Boolean)

    fetch(this.allTableIdsUrlValue)
      .then(resp => resp.json())
      .then(data => this.selectionFieldTarget.value = data.data.filter(id => !unchecked.includes(id)).join(','))

    this.selectionListTarget.innerHTML += ' ... and other pages.'
  }

  get dataKey() {
    return this.keyValue.replace(/-([a-z])/g, (_, c) => c.toUpperCase())
  }
}
